module.exports = __webpack_public_path__ + "static/img/mingf11.6b793dde.png";